import { Schema, string } from 'lib/schema';

export default class ShowUser extends Schema {
  @string id = { default: null, path: 'id' };

  @string name = { default: '' };

  @string avatar = { default: '' };

  @string role = { default: 'unknown' };
}
